import { DaySelection as DaySelectionType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import Core from './Core'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import checkForAvailability from './helper/checkForAvailability'

const DaySelection: React.FC<Props<DaySelectionType>> = ({ survey, element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div>
      {checkForAvailability(survey, element.type) ? (
        <Core element={element} update={update} />
      ) : (
        <div>{t.survey.configuration.daySelection.amountOfDaysMissing}</div>
      )}
    </div>
  )
}

export default DaySelection
